module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center my-3"
  }, [_c('span', {
    staticClass: "darker font-weight-600 mr-2",
    on: {
      "click": _vm.testCalc
    }
  }, [_vm._v("\n\t\t\t\tSeller:\n\t\t\t")]), _vm._v(" "), _c('seller-picker', {
    staticClass: "w-100",
    attrs: {
      "reservation": _vm.reservation,
      "orignalSeller": _vm.reservation.creatorAgent ? _vm.reservation.creatorAgent : _vm.account,
      "agentList": _vm.eventPossibleAgentsList(_vm.reservation.event),
      "hideOthers": false,
      "inlcudeWidget": true,
      "hideGetYourGuide": true,
      "hideViator": true,
      "hideAllByChannel": true
    },
    on: {
      "input": _vm.sellerChanged
    }
  })], 1), _vm._v(" "), (_vm.getOrigins.length !== 0) ? _c('div', {
    staticClass: "custom_grid my-3"
  }, [_c('div', {
    staticClass: "darker font-weight-600 mr-2"
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [(_vm.originsRequired) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("Origin")])]), _vm._v(" "), _c('div', [_c('v-select', {
    staticClass: "w-100",
    class: {
      'reservation__dropdown--error': _vm.hasOriginError
    },
    attrs: {
      "label": "name",
      "options": _vm.originsOptions,
      "reduce": function (origin) { return origin.id; }
    },
    on: {
      "input": _vm.originChanged
    },
    model: {
      value: (_vm.origin),
      callback: function($$v) {
        _vm.origin = $$v
      },
      expression: "origin"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.getSegments.length !== 0) ? _c('div', {
    staticClass: "custom_grid my-3"
  }, [_c('div', {
    staticClass: "darker font-weight-600 mr-2"
  }, [_c('span', {
    staticClass: "fs-small bold"
  }, [(_vm.segmentsRequired) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("Segment")])]), _vm._v(" "), _c('div', [_c('v-select', {
    staticClass: "w-100",
    class: {
      'reservation__dropdown--error': _vm.hasSegmentError
    },
    attrs: {
      "label": "name",
      "options": _vm.segmentsOptions,
      "reduce": function (segment) { return segment.id; }
    },
    on: {
      "input": _vm.segmentChanged
    },
    model: {
      value: (_vm.segment),
      callback: function($$v) {
        _vm.segment = $$v
      },
      expression: "segment"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b0a1ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Summary/AgentSelector.vue
// module id = 2498
// module chunks = 0